import Api from '@/services/Api'

export default {
  getColorsByFabric (fabricID) {
    return Api().get('colors/' + fabricID)
  },

  getColor (colorID) {
    return Api().get('color/' + colorID)
  },

  createColor (color) {
    return Api().post('colors/', color)
  },

  updateColor (color) {
    return Api().put('color/' + color._id, color)
  },

  countColors (fabricID) {
    return Api().get('colorCount/' + fabricID)
  },

  deleteColor (colorID) {
    return Api().delete('color/' + colorID)
  },

  setExpress (colorID, express) {
    return Api().post('color/express/' + colorID, {
      express: express
    })
  },

  addTag (params) {
    return Api().post('addColorTag/', params)
  },

  deleteTag (params) {
    return Api().post('deleteColorTag/', params)
  },

  uploadImage (id, size, formData) {
    return Api().post(`colors/uploadImage/${size}/${id}`, formData)
  }
}



// WEBPACK FOOTER //
// ./src/services/ColorService.js